// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:16
import { State_abstract } from './../abstract/SagaBase/State_abstract';
export class State extends State_abstract {}
